var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#EFF6E1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_127_6688",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_127_6688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 19C5 17.1833 5.75833 15.7292 7.275 14.6375C8.79167 13.5458 10.5333 13 12.5 13C14.4667 13 16.2083 13.5458 17.725 14.6375C19.2417 15.7292 20 17.1833 20 19H5ZM5 23V21H20V23H5ZM6 27C5.71667 27 5.47917 26.9042 5.2875 26.7125C5.09583 26.5208 5 26.2833 5 26V25H20V26C20 26.2833 19.9042 26.5208 19.7125 26.7125C19.5208 26.9042 19.2833 27 19 27H6ZM22 27V19C22 17.1 21.35 15.4583 20.05 14.075C18.75 12.6917 17.1583 11.7667 15.275 11.3L15 9H20V5H22V9H27L25.375 25.2C25.325 25.7167 25.1125 26.1458 24.7375 26.4875C24.3625 26.8292 23.9167 27 23.4 27H22Z",
    fill: "#6BB700"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderActive);
export default __webpack_public_path__ + "static/media/order-active.b189c1099136d6a3b74bd79a936bb019.svg";
export { ForwardRef as ReactComponent };